export default function AttachAgendaItemFolderDirective() {
  return {
    template: require('./attach-agendaItem-folder.html'),
    scope: {
      customerId: '=',
      agendaItemId: '=',
      serviceId: '=',
      parentFolderId: '=',
      folderId: '=',
      folder: '=',
    },
    controller: 'AttachAgendaItemFolderController',
    controllerAs: 'attachAgendaItemFolderVM',
    bindToController: true,
    replace: true
  };
}
